import Vue from 'vue'
import Router from 'vue-router'
import store from './store/index'
import axios from './api/axios'
import help from "./help"

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/cart/scan',
      meta: {}
    },
    {
      path: '/cart/live-locations',
      name: 'Dashboard',
      component: () => import('./views/cart/Dashboard.vue'),
      meta: {
        title: 'Cart Live Locations',
        auth: {
          required: true,
          permission: "ViewStats"
        },
        help: help.CartLiveLocations
      }
    },
    {
      path: '/cart/scan',
      name: 'cartscan',
      component: () => import('./views/cart/Scan.vue'),
      meta: {
        title: 'Cart Scan',
        auth: {
          required: true,
          permission: "ScanCarts"
        },
        help: help.CartScan
      }
    },
    {
      path: '/cart/scan-log',
      name: 'Cart Scan Log',
      component: () => import('./views/cart/Log.vue'),
      meta: {
        title: 'Cart Scan Log',
        auth: {
          required: true,
          permission: "ViewCartsScanLog"
        },
        help: help.CartScanLog
      }
    },
    {
      path: '/cart/bill-of-lading',
      name: 'Bill Of Lading',
      component: () => import('./views/cart/Sessions.vue'),
      meta: {
        title: 'Bill Of Lading',
        auth: {
          required: true,
          permission: "PrintBol"
        },
        help: help.CartBillOfLading
      }
    },
    {
      path: '/cart/mirror-zone',
      name: 'Mirror Zone',
      component: () => import('./views/MirrorZoneView.vue'),
      meta: {
        title: 'Mirror Zone',
        auth: {
          required: true,
          permission: "ViewMirrorZones"
        },
        help: help.CartBillOfLading
      }
    },
    {
      path: '/trackingorder/scan',
      name: 'Transfer Order Scan',
      component: () => import('./views/tracking_order/Scan.vue'),
      // TODO not working
      meta: {
        title: 'Transfer Order Scan',
        auth: {
          required: true,
          permission: "ScanTrackingOrders"
        },
        help: help.TOScan
      }
    },
    {
      path: '/trackingorder/log',
      name: 'Transfer Order Log',
      component: () => import('./views/tracking_order/log.vue'),
      // TODO not working
      meta: {
        title: 'Transfer Order Log',
        auth: {
          required: true,
          permission: "ViewTrackingOrderLog"
        },
        help: help.TOScanLog
      }
    },
    {
      path: '/manage/users',
      name: 'Manage Users',
      props: { editPermissionName: "EditUsers" },
      component: () => import('./views/users.vue'),
      meta: {
        title: 'Manage Users',
        auth: {
          required: true,
          permission: "ViewUsers"
        }
      }
    },
    {
      path: '/manage/roles',
      name: 'Manage Roles',
      props: { editPermissionName: "EditRoles" },
      component: () => import('./views/roles.vue'),
      meta: {
        title: 'Manage Users',
        auth: {
          required: true,
          permission: "ViewRoles"
        }
      }
    },
    {
      path: '/manage/work-centers',
      name: 'Manage Work Centers',
      props: { model: "workcenters", modelName: "Work Center", editPermissionName: "EditWorkCenters" },
      component: () => import('./views/ModelOneMngmnt.vue'),
      meta: {
        title: 'Manage Users',
        auth: {
          required: true,
          permission: "ViewWorkCenters"
        }
      }
    },
    {
      path: '/manage/modules',
      name: 'Manage Modules',
      props: { model: "modules", modelName: "Module", editPermissionName: "EditModules" },
      component: () => import('./views/ModelOneMngmnt.vue'),
      meta: {
        title: 'Manage Users',
        auth: {
          required: true,
          permission: "ViewModules"
        }
      }
    },
    {
      path: '/manage/contracts',
      name: 'Manage Contracts & Scan Flows',
      props: { model: "contracts", modelName: "Contract", editPermissionName: "EditContracts" },
      component: () => import('./views/contracts.vue'),
      meta: {
        title: 'Manage Contracts',
        auth: {
          required: true,
          permission: "ViewContracts"
        }
      }
    },
    {
      path: '/manage/locations',
      name: 'Manage Locations',
      props: { editPermissionName: "EditLocations" },
      component: () => import('./views/locations.vue'),
      meta: {
        title: 'Manage Locations',
        auth: {
          required: true,
          permission: "ViewLocations"
        }
      }
    },
    {
      path: '/manage/mirrorzones',
      name: 'Manage Mirror Zones',
      props: { editPermissionName: "EditLocations" },
      component: () => import('./views/mirrorzones.vue'),
      meta: {
        title: 'Manage Mirror Zones',
        auth: {
          required: true,
          permission: "ViewLocations"
        }
      }
    },
    {
      path: '/manage/lhgs',
      name: 'Manage Logistics Handling Group',
      props: { editPermissionName: "EditLocations" },
      component: () => import('./views/lhgs.vue'),
      meta: {
        title: 'Manage Logistics Handling Group',
        auth: {
          required: true,
          permission: "ViewLocations"
        }
      }
    },
    {
      path: '/manage/states',
      name: 'Manage States',
      props: { model: "states", modelName: "Cart Status", editPermissionName: "EditStates" },
      component: () => import('./views/states.vue'),
      meta: {
        title: 'Manage Status',
        auth: {
          required: true,
          permission: "ViewStates"
        }
      }
    },
    {
      path: '/manage/stations',
      name: 'Manage Stations',
      props: { editPermissionName: "EditStations" },
      component: () => import('./views/stations.vue'),
      meta: {
        title: 'Manage Stations',
        auth: {
          required: true,
          permission: "ViewStations"
        }
      }
    },
    {
      path: '/manage/stationgroups',
      name: 'Manage Station Groups',
      props: { editPermissionName: "EditStationGroups" },
      component: () => import('./views/StationGroups.vue'),
      meta: {
        title: 'Manage Station Groups',
        auth: {
          required: true,
          permission: "ViewStationGroups"
        }
      }
    },
    {
      path: '/manage/linemovedates',
      name: 'Line Move Dates',
      props: { editPermissionName: "EditLineMoveDates" },
      component: () => import('./views/LineMoveDates.vue'),
      meta: {
        title: 'Manage Line Move Dates',
        auth: {
          required: true,
          permission: "ViewLineMoveDates"
        }
      }
    },
    {
      path: '/manage/carts',
      name: 'Manage Carts',
      props: { editPermissionName: "EditCarts" },
      component: () => import('./views/carts.vue'),
      meta: {
        title: 'Manage Carts',
        auth: {
          required: true,
          permission: "ViewCarts"
        }
      }
    },
    {
      path: '/manage/trackingorders',
      name: 'Manage Transfer Orders',
      props: { editPermissionName: "EditTrackingOrders" },
      component: () => import('./views/tracking_order/items.vue'),
      meta: {
        title: 'Manage Transfer Orders',
        auth: {
          required: true,
          permission: "ViewTrackingOrders"
        }
      }
    },
    {
      path: '/manage/settings',
      name: 'Settings',
      props: { editPermissionName: "EditSettings" },
      component: () => import('./views/Settings.vue'),
      meta: {
        title: 'Settings',
        auth: {
          required: true,
          permission: "ViewSettings"
        }
      }
    },
    {
      path: '/signin',
      name: 'signin',
      component: () => import('./views/Signin.vue'),
      meta: {
        title: 'Sign In',
      }
    },
    {
      path: '/recovery',
      name: 'recovery',
      component: () => import('./views/Recovery.vue'),
      meta: {
        title: 'Password Recovery',
      }
    },
    {
      path: '/password-reset',
      name: 'password-reset',
      component: () => import('./views/PasswordReset.vue'),
      meta: {
        title: 'Password Reset',
      }
    },
    {
      path: '/account',
      name: 'Account Details',
      component: () => import('./views/account/index.vue'),
      meta: {
        title: 'Account - Details',
        auth: {
          required: true
        }
      }
    },
    {
      path: '/account/change-password',
      name: 'Account - Change Password',
      component: () => import('./views/account/change-password.vue'),
      meta: {
        title: 'Account - Change Password',
        auth: {
          required: true
        }
      }
    },
    {
      path: '/manage/contracts/flow/:id',
      name: 'Edit - Flow',
      props: { editPermissionName: "EditFlows" },
      component: () => import('./views/flow/editflow.vue'),
      meta: {
        title: 'Manage - Flow',
        auth: {
          required: true,
          permission: "ViewFlows"
        }
      }
    },
    {
      path: "/help",
      name: "Help",
      component: () => import('./views/Help.vue'),
      meta: {
        title: 'Help',
        auth: {
          required: true
        }
      }
    },
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      meta: {
        title: 'About',
        auth: {
          required: true
        }
      }
    }, {
      // REDIRECT TO HOME ON 404
      path: '*',
      name: "not found",
      redirect: '/'
    }
  ]
})

const defaultPagesPriority = [
  "/cart/scan",
  "/cart/scan-log",
  "/cart/live-locations",
  "/trackingorder/scan",
  "/trackingorder/log",
  "/about",
  "/signin"
]

router.beforeEach(async (to, from, next) => {
  await utils.setUserStatus()
  if (utils.userHasRoutePerm(to.path)) {
    next()
  } else {
    next({
      path: utils.findNextPage()
    })
  }
})

const utils = {
  setUserStatus: async function () {
    try {
      const res = await axios.get("/auth/status")
      const data = res.data
      if (data.d.signedIn) {
        store.commit("user/set", data.d.user);
      } else {
        store.commit("user/clear");
      }
    } catch (error) {
      console.log(error)
    }
  },
  findNextPage: function () {
    for (let i = 0; i < defaultPagesPriority.length; i++) {
      if (this.userHasRoutePerm(defaultPagesPriority[i])) {
        return defaultPagesPriority[i]
      }
    }
    return '/signin'
  },
  userHasRoutePerm: function (route) {
    const routeObj = router.match(route);
    if (!routeObj) return false;
    if (routeObj.meta && routeObj.meta.auth) {
      if (!store.getters.isLoggedIn) {
        return false;
      }
      if (
        routeObj.meta.auth.permission &&
        !store.getters.hasPerm(routeObj.meta.auth.permission)
      ) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  }
}

export default router
export { utils }
